// Anchor Watch remote view — mirrors vortex-api routes/anchorRemote.ts + services/anchorRemoteService.ts.

export type AnchorRemoteMode = 'watch' | 'fixed';

export interface AnchorRemoteDevice {
  deviceId: string;
  name: string | null;
  vesselName: string | null;
  serialNumber: string;
  status: string;
  lastSeenAt: string | null;
  /** The relay READ token, 26 characters, or null when the Scout holds no link. */
  token: string | null;
  /** 'watch' = a new address per anchor watch; 'fixed' = one address kept for the Scout. */
  mode: AnchorRemoteMode;
  /** The Scout's last report: is an anchor watch set, and is it publishing. */
  armed: boolean;
  publishing: boolean;
  tokenChangedAt: string | null;
  updatedAt: string | null;
}

/** Where the relay answers. Same constant the Scout and the Flutter app use. */
export const ANCHOR_RELAY_BASE = 'https://api.vortexnav.com';

export const anchorRemoteUrl = (token: string) => `${ANCHOR_RELAY_BASE}/w/${token}`;
export const anchorRelayJsonUrl = (token: string) => `${ANCHOR_RELAY_BASE}/api/anchor/w/${token}`;
